import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { trackEvent } from 'analytics/trackFunctions'

import ErrorIcon from 'assets/icons/ErrorIcon'
import PageWrapper from 'components/PageWrapper'
import PrimaryButton from 'components/primaryButton'
import InfoCard from 'components/InfoCard'

const NewAccountError = () => {
  const navigate = useNavigate()

  useEffect(() => {
    trackEvent({ eventName: 'bille_pantalla_error_cuenta' })
  }, [])

  return (
    <PageWrapper noTabBar title='Transferencia' viewSelected='/movimientos'>
      <section className='h-[calc(100vh-12rem)] text-black mx-auto justify-center sm:max-w-[22.5rem]'>
        <ErrorIcon className='mx-auto' />
        <h2 className='text-xl font-bold text-center my-4'>
          Ha ocurrido un error
        </h2>
        <InfoCard className='mb-6'>
          <p>No encontramos cuentas asociadas a la información ingresada.</p>
          <p>Por favor revisá si tuviste un error en el tipeo.</p>
        </InfoCard>

        <div className='mt-auto space-y-4'>
          <PrimaryButton
            buttonText='Volver a intentar'
            primaryButtonFunction={() =>
              navigate('/transferencias/nueva-cuenta')
            }
          />
          <PrimaryButton
            buttonText='Volver al inicio'
            outlined
            primaryButtonFunction={() => navigate('/transferencias')}
          />
        </div>
      </section>
    </PageWrapper>
  )
}

export default NewAccountError
